// src/components/modals/web-modals/components/ContactFormComponent.jsx

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import DataProtectionInformationContactForm from './DataProtectionInformationContactForm';

const ContactFormComponent = ({ initialMessage = "" }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: initialMessage,
    acceptPrivacyPolicy: false
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

  useEffect(() => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      message: initialMessage || ''
    }));
    setFormSubmitted(false);
  }, [initialMessage]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.acceptPrivacyPolicy) {
      alert(t('you_must_accept_privacy_policy'));
      return;
    }

    axios.post(`${apiUrl}/contact/send-message`, formData)
      .then(() => {
        setFormSubmitted(true);
      })
      .catch(error => {
        console.error('❌ Error sending contact form:', error);
        alert(t('there_was_an_error_sending_your_message'));
      });
  };

  return (
    <div className="web-modal-form">
      {formSubmitted ? (
        <div className="confirmation-message centered-text">
          <h2>{t('thank_you')}</h2>
          <p>{t('your_message_has_been_sent')}</p>
        </div>
      ) : (
        <>
          <h2 className="centered-text">{t('contact_us')}</h2>
          <p className="web-modal-text-muted centered-text">{t('contact_form_explanation')}</p>

          <form onSubmit={handleSubmit} className="web-modal-form">
            <label>{t('your_name')}</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="web-modal-input"
            />

            <label>{t('your_email')}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="web-modal-input"
            />

            <label>{t('your_message')}</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              className="web-modal-input web-modal-textarea"
              rows="4"
            />

            <DataProtectionInformationContactForm
              formData={formData}
              handleChange={handleChange}
              fontSize="0.85em"
            />

            <button type="submit" className="web-modal-button">
              {t('get_in_touch')}
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default ContactFormComponent;
